import React, { useEffect } from "react";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import OurValues from "../components/values/OurValues";
import TeamComponent from "../components/team/TeamDetailed";
import { useLocation } from "react-router-dom";
import AboutComponent from "../components/about/About";
import { useGeneralSheetHook } from "../hooks/sheet.hook";
import HeaderComponent from "../common/header/Header";
import SEO from "../common/seo/SEO";

const About = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <SEO path={"/about"} prefix={"About Us"} />
      <HeaderComponent />
      <Breadcrumb heading="About Us" currentPage="About" />
      <section id="what-we-do">
        <AboutComponent />
      </section>
      <OurValues />
      <TeamComponent />
      <Footer />
    </>
  );
};

export default About;
